<template>
  <v-dialog
    :value="dialog"
    max-width="60rem"
    scrollable
    @click:outside="closeDialog()"
  >
    <v-card>
      <v-toolbar
        dark
        dense
        color="primary"
      >
        <v-toolbar-title>Draw a chemical</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="py-2">
        <KetcherEditor
          v-model="mol"
          resolve
          show-found
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          @click="onAdd()"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { eventBus } from '@/main'
import KetcherEditor from '@/components/ketcher-editor/KetcherEditor.vue'

export default {
  components: {
    KetcherEditor,
  },

  data() {
    return {
      // dialog: true,
      mol: null,
    }
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  // watch: {
  //   dialog(val) {
  //     console.log('Ketcher dialog visibility changed:', val)
  //     if (!val) this.$emit('close')
  //   },
  // },

  methods: {
    closeDialog() {
      this.$emit('close')
    },

    onAdd() {
      console.log('Adding structure from Ketcher dialog:', this.mol)
      eventBus.$emit('ADD_STRUCTURE', this.mol)
      this.closeDialog()
    },
  },
}
</script>
